<template>
  <div class="ksm-modus__komposition-wrapper">
    <split-layout :col="2" :sidebar_right_collapse="false">
      <!-- split-layout main -->
      <div slot="main-content" class="ksm-texte__modus-main">
        <!-- toolbar -->
        <slot name="modusindex-toolbar"></slot>
        <!-- main content -->
        <div class="ksm-modus__komposition-main">
          <div class="canvas-container-wrapper">
            <div class="canvas-container">
              <fabric-comp
                ref="fabricComp"
                @eventFromOSDViewer="updateRightViewer"
                @changePage="selectPage"
                @imageOpened="imageOpened"
                :modusOption="modusOption"
                :seiteIdx="seiteIdx"
                :seiten="seiten"
                key="deep_komposition_1"
              ></fabric-comp>
            </div>
          </div>
          <div class="ksm-flex-xy-center" style="width:36px">
            <div style="width:1px; height:100%; background-color:grey"></div>
          </div>
          <div class="fasimily-container">
            <fasimile-comp
              ref="fasimileComp"
              @eventFromOSDViewer="updateLeftViewer"
              @changePage="selectPage"
              @imageOpened="imageOpened"
              :modusOption="modusOption"
              :seiteIdx="seiteIdx"
              :seiten="seiten"
              key="deep_komposition_2"
            ></fasimile-comp>
          </div>
        </div>
        <!--  main content end -->
      </div>

      <!-- spit-layout sidebar -->
      <div slot="sidebar-2" class="ksm-flex-1 furniture" style="position:relative">
        <sidebar-view
          readonly
          :merz="merz"
          :modusOption="modusOption"
          @imgDragStart="handleDragStart"
          @imgDragEnd="handleDragEnd"
          :seiteIdx="seiteIdx"
        ></sidebar-view>
      </div>
    </split-layout>
  </div>
</template>

<script>
import Sidebar from "./Sidebar.vue";
import SplitLayout from "comps/SplitLayout.vue";
import { mapGetters } from "vuex";
import DeepzoomView from "comps/DeepzoomView.vue";
import FabricView from "comps/FabricView.vue";
import { fabric } from "fabric";

import MixinsModus from "comps/mixins/Modus.vue";

export default {
  mixins: [MixinsModus],
  components: {
    "split-layout": SplitLayout,
    "fasimile-comp": DeepzoomView,
    "fabric-comp": FabricView,
    "sidebar-view": Sidebar
  },
  props: {
    viewKey: String
  },
  data() {
    return {
      modusId: "kompositionsmodus",
      images: [],
      imageOffsetX: 0,
      imageOffsetY: 0,
      canvasOffset: null,
      canvas: null,
      canvasContainer: null,
      deepzoomOpened: false,
      zoom: null,
      syncZoomEnable: false
    };
  },
  watch: {
    fetchCropImages() {
      const vue = this;
      const handleDragStart = vue.handleDragStart;
      const handleDragEnd = vue.handleDragEnd;
      const furniture = this.$el.querySelector(".furniture");
      const images = furniture.querySelectorAll("img");
      vue.images = images;
      images.forEach(img => {
        img.addEventListener("dragstart", handleDragStart, false);
        img.addEventListener("dragend", handleDragEnd, false);
      });
    },
    seite() {
      if (this.fetchCropImages) {
        return;
      }
      this.images = [];
    }
  },
  mounted: function() {
    this.fabricComp = this.$refs["fabricComp"];
    this.fabricViewer = this.fabricComp.viewer;
    this.fabricjsOverlay = this.fabricComp.fabricjsOverlay;
    this.fabricjsOverlayCanvas = this.fabricjsOverlay.canvas();
    this.fabricCanvas = this.fabricjsOverlay.fabricCanvas();

    this.fasimileComp = this.$refs["fasimileComp"];
    this.fasimileViewer = this.fasimileComp.viewer;
    this.initFabricCanvasDrag();
  },
  activated() {
    const zoom = this.zoom;
    if (zoom > 0 && this.fabricViewer) {
      const viewport = this.fabricViewer.viewport;
      // setTimeout(function() {
      //   viewport.zoomTo(zoom, true);
      // }, 500);
    }
  },
  deactivated() {
    this.zoom = this.fabricViewer.viewport.getZoom();
  },
  computed: {
    fetchCropImages() {
      const seite = this.seite;
      if (!seite || !seite._.fetchCropImagesEnd) {
        return;
      }
      return true;
    }
  },

  methods: {
    /*************************************************************
     *********/
    initFabricCanvasDrag() {
      const vue = this;
      const canvasContainer = vue.fabricViewer.container;
      function handleDragOver(e) {
        if (e.preventDefault) {
          e.preventDefault();
        }
        e.dataTransfer.dropEffect = "copy";
        return false;
      }

      function handleDragEnter(e) {
        this.classList.add("over");
      }

      function handleDragLeave(e) {
        this.classList.remove("over");
      }

      function handleDrop(e) {
        e = e || window.event;
        if (e.preventDefault) {
          e.preventDefault();
        }

        const fabricCanvas = vue.fabricCanvas;
        const canvasOffset = vue.fabricViewer.container.getBoundingClientRect();
        const offsetPoint = vue.fabricjsOverlay.offsetPoint();
        const fabricZoom = fabricCanvas.getZoom();

        if (e.stopPropagation) {
          e.stopPropagation();
        }
        const draggingImg = vue.$el.querySelector(
          ".furniture img.img_dragging"
        );
        if (!draggingImg) {
          return;
        }

        const y =
          e.clientY - (canvasOffset.top + vue.imageOffsetY - offsetPoint.y);
        const x =
          e.clientX - (canvasOffset.left + vue.imageOffsetX - offsetPoint.x);

        const w = draggingImg.width / fabricZoom;
        const h = draggingImg.height / fabricZoom;

        const newImage = new fabric.Image(draggingImg, {
          width: w,
          height: h,
          left: x / fabricZoom,
          top: y / fabricZoom
        });
        const trID = draggingImg.getAttribute("data-trid");
        newImage.set("id", vue.getImgFileName(trID));

        fabricCanvas.add(newImage);
        return false;
      }

      canvasContainer.addEventListener("dragenter", handleDragEnter, false);
      canvasContainer.addEventListener("dragover", handleDragOver, false);
      canvasContainer.addEventListener("dragleave", handleDragLeave, false);
      canvasContainer.addEventListener("drop", handleDrop, false);
    },

    getImgFileName(trID) {
      if (!this.seite || !this.seite.$_allTranscripts) {
        return trID;
      }
      const obj = this.seite.$_allTranscripts.find(obj =>
        obj.transcripts.find(tr => tr.id === trID)
      );
      if (obj) {
        const docID = obj.docID;
        const doc = this.seite.docs.find(d => d.docID - docID === 0);
        if (doc) {
          trID = trID + "#" + doc.filename;
        }
      }
      return trID;
    },

    /*************************************************************
     *********/
    updateRightViewer(playload) {
      if (!this.syncZoomEnable) {
        return;
      }
      const viewport = this.fasimileViewer.viewport;
      switch (playload.type) {
        case "canvas-drag":
          if (!this.syncZoomEnable) {
            return;
          }
          if (viewport.getCenter() - playload.center !== 0) {
            viewport.panTo(playload.center, false);
          }
          break;

        case "zoom":
          if (!this.syncZoomEnable) {
            return;
          }
          if (playload.zoom - viewport.getZoom() !== 0) {
            viewport.zoomTo(playload.zoom, true);
            viewport.panTo(playload.center, false);
          }
          break;
      }
    },
    /*************************************************************
     *********/
    updateLeftViewer(playload) {
      const viewport = this.fabricViewer.viewport;
      switch (playload.type) {
        case "canvas-drag":
          if (!this.syncZoomEnable) {
            return;
          }
          if (viewport.getCenter() - playload.center !== 0) {
            viewport.panTo(playload.center, false);
          }
          break;

        case "zoom":
          if (!this.syncZoomEnable) {
            return;
          }
          if (playload.zoom - viewport.getZoom() !== 0) {
            viewport.zoomTo(playload.zoom, true);
            viewport.panTo(playload.center, false);
          }
          break;

        case "transcript-double-click":
          this._addTranscriptElementPerClick(playload);
          break;

        case "dragTranscriptElementEnd":
          this._addTranscriptElementPerDrag(playload);
          break;
      }
    },
    /*************************************************************
     *********/
    _addTranscriptElementPerDrag(playload) {
      const div = playload.div;
      if (!div) {
        return;
      }
      const fabricCanvas = this.fabricCanvas;
      const divOffset = div.getBoundingClientRect();
      const canvasOffset = this.fabricViewer.container.getBoundingClientRect();
      const offsetPoint = this.fabricjsOverlay.offsetPoint();
      const fabricZoom = fabricCanvas.getZoom();

      if (
        canvasOffset.left + canvasOffset.width - divOffset.width <
          divOffset.left ||
        divOffset.height + divOffset.top >
          canvasOffset.top + canvasOffset.height
      ) {
        document.body.removeChild(div);
        return;
      }

      const imgCanvas = div.querySelector("canvas");
      const w = imgCanvas.width / fabricZoom;
      const h = imgCanvas.height / fabricZoom;
      const x = divOffset.left - canvasOffset.left + offsetPoint.x;
      const y = divOffset.top - canvasOffset.top + offsetPoint.y;

      const img = new fabric.Image(imgCanvas, {
        width: w,
        height: h,
        left: x / fabricZoom,
        top: y / fabricZoom
      });
      const trID = div.getAttribute("data-trid");
      img.set("id", this.getImgFileName(trID));
      fabricCanvas.add(img);
      fabricCanvas.setActiveObject(img);
      document.body.removeChild(div);
    },
    /*************************************************************
     *********/
    _addTranscriptElementPerClick(playload) {
      const transcripts = playload.data;
      const div = playload.dragDiv;

      if (!transcripts) {
        document.body.removeChild(div);
        return;
      }
      const fabricViewer = this.fabricViewer;
      const viewport = fabricViewer.viewport;
      const ctx = fabricViewer.drawer.context;
      const fabricCanvas = this.fabricCanvas;
      const canvasOffset = fabricViewer.container.getBoundingClientRect();

      transcripts.forEach(tr => {
        const pos = viewport.imageToViewerElementCoordinates(
          new OpenSeadragon.Point(tr.x, tr.y)
        );
        const viewportZoom = viewport.getZoom(true);
        const image1 = fabricViewer.world.getItemAt(0);
        const zoom = image1.viewportToImageZoom(viewportZoom);
        const fabricZoom = fabricCanvas.getZoom();

        const [x, y, w, h] = [
          Number(pos.x),
          Number(pos.y),
          Number(tr.w * zoom),
          Number(tr.h * zoom)
        ];

        const [x2, y2, w2, h2] = [
          Number((tr.x * zoom) / fabricZoom),
          Number((tr.y * zoom) / fabricZoom),
          Number((tr.w * zoom) / fabricZoom),
          Number((tr.h * zoom) / fabricZoom)
        ];

        if (x < 0 || y < 0 || w < 1 || h < 1) {
          return;
        }

        div.addEventListener(
          "transitionend",
          function(event) {
            const data = ctx.getImageData(x, y, w, h);
            var c = document.createElement("canvas");
            c.setAttribute("id", "_temp_canvas");
            c.width = w;
            c.height = h;
            c.getContext("2d").putImageData(data, 0, 0);
            fabric.Image.fromURL(c.toDataURL(), function(img) {
              img.left = x2;
              img.top = y2;
              img.width = w2;
              img.height = h2;
              img.id = tr.content;

              fabricCanvas.add(img);
              img.bringToFront();
              fabricCanvas.setActiveObject(img);
            });
            div.parentNode && div.parentNode.removeChild(div);
          },
          false
        );
        div.style.left = x + canvasOffset.left + "px";
      });
    },
    /*************************************************************
     *********/
    updateViewport() {
      return;
      if (!this.deepzoomOpened) {
        return;
      }

      const canvas = this.canvas;
      canvas.clear();
      const fasimileViewer = this.fasimileViewer;
      const viewport = fasimileViewer.viewport;
      const ctx = fasimileViewer.drawer.context;
      if (deepzoom.transcripts && deepzoom.transcripts.length < 1000) {
        deepzoom.transcripts.forEach(tr => {
          const pos = viewer.viewport.imageToViewerElementCoordinates(
            new OpenSeadragon.Point(tr.x, tr.y)
          );
          const viewportZoom = viewer.viewport.getZoom(true);
          const rotate = viewer.viewport.getRotation();
          const image1 = viewer.world.getItemAt(0);
          const zoom = image1.viewportToImageZoom(viewportZoom);

          const [x, y, w, h] = [
            Number(pos.x),
            Number(pos.y),
            Number(tr.w * zoom),
            Number(tr.h * zoom)
          ];

          if (x < 0 || y < 0 || w < 1 || h < 1) {
            return;
          }

          const data = ctx.getImageData(x, y, w, h);
          var c = document.createElement("canvas");
          c.setAttribute("id", "_temp_canvas");
          c.width = w;
          c.height = h;
          c.getContext("2d").putImageData(data, 0, 0);
          fabric.Image.fromURL(c.toDataURL(), function(img) {
            img.left = x;
            img.top = y;
            img.id = tr.content;
            canvas.add(img);
            img.bringToFront();
            canvas.setActiveObject(img);
          });
        });
      }
    },
    /*************************************************************
     *********/
    imageOpened() {
      this.deepzoomOpened = true;
    },
    /*************************************************************
     *********/
    selectPage(i) {
      this.$_modusChangeEvent("modus/changeSeite", i);
    },
    /*************************************************************
     *********/
    resizeCanvas() {
      this.canvas.setHeight(this.canvasContainer.clientHeight);
      this.canvas.setWidth(this.canvasContainer.clientWidth);
    },
    /*************************************************************
     *********/
    handleDragStart(e) {
      const vue = this;
      const targetImg = e.target;
      const images = vue.$el.querySelector(".furniture img.img_dragging");
      if (images) {
        [].forEach.call(images, function(img) {
          img.classList.remove("img_dragging");
        });
      }
      targetImg.classList.add("img_dragging");
      let imageOffset = $(targetImg).offset();
      this.imageOffsetX = e.clientX - imageOffset.left;
      this.imageOffsetY = e.clientY - imageOffset.top;
    },

    /*************************************************************
     *********/
    handleDragEnd(e) {
      e.target.classList.remove("img_dragging");
    },

    /*************************************************************
     *********/
    save() {
      const canvas = this.canvas;
      const o = canvas.toJSON(["id"]);
      console.log(JSON.stringify(o));
    },

    /*************************************************************
     *********/

    loadTest() {}
  }
};
</script>

<style lang="scss"
 scoped>
.ksm-modus__komposition-wrapper {
  @extend .ksm-flex;
  @extend .ksm-content-font;
  justify-content: center;
}

.ksm-modus__komposition-main {
  @extend .ksm-flex-1;
  @extend .ksm-flex;
  padding: 10px 20px;
}

.canvas-container-wrapper {
  @extend .ksm-flex-1;
  @extend .ksm-flex;
  // border: 1px solid #fff;
}

.canvas-container {
  @extend .ksm-flex-1;
  @extend .ksm-flex;
}

.fasimily-container {
  @extend .ksm-flex-1;
  @extend .ksm-flex;
  // border: 1px solid #fff;
}
</style>


// WEBPACK FOOTER //
// Komposition.vue?762cdf34